import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/app/services/Helper/helper.service';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import { User } from 'src/app/models/ui/User';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-sec-questions',
  templateUrl: './sec-questions.component.html',
  styleUrls: ['./sec-questions.component.css']
})
export class SecurityQuestionsComponent implements OnInit {
  isAuthorized: string;

  user: User;

  questions = [
  {question: "What was the house number and street name you lived in as a child?"},
  {question:"What were the last four digits of your childhood telephone number?"},
  {question:"What primary school did you attend?"},
  {question:"In what town or city was your first full time job?"},
  {question:"In what town or city did you meet your spouse or partner?"},
  {question:"What is the middle name of your oldest child?"},
  {question:"What are the last five digits of your driver's license number?"},
  {question:"What is your grandmother's (on your mother's side) maiden name?"},
  {question:"What is your spouse or partner's mother's maiden name?"},
  {question:"In what town or city did your parents meet?"},
  {question:"What time of the day were you born? (hh:mm)"},
  {question:"What time of the day was your first child born? (hh:mm)"}
  ];

  firstQuestionValue: string;
  firstAnswerValue: string;
  secondQuestionValue: string;
  secondAnswerValue: string;

  constructor(private helperService: HelperService, private lookupService: LookupService,
    private userService: UserService) { 
    this.user = new User();
  }

  ngOnInit() {
    this.isAuthorized = localStorage.getItem("isAuthorized");

    if(this.isAuthorized === "true") {
    this.helperService.setTitle("Provider - Security Questions");
    
    this.lookupService.getUser().subscribe(data => this.user = data);
  }
  else
    location.assign("#/login-form");
  }

  changeFirstQuestion(e) {
    this.firstQuestionValue = e.value;
  }

  changeFirstAnswer(e) {
    this.firstAnswerValue = e.value;
  }

  changeSecondQuestion(e) {
    this.secondQuestionValue = e.value;
  }

  changeSecondAnswer(e) {
    this.secondAnswerValue = e.value;
  }

  submitChanges() {
    setTimeout(() => {
      this.user.FirstQuestion = this.firstQuestionValue;
      this.user.FirstAnswer = this.firstAnswerValue;
      this.user.SecondQuestion = this.secondQuestionValue;
      this.user.SecondAnswer = this.secondAnswerValue;
      
      this.userService.updateUserData(this.user).subscribe(data => this.afterUpdate(data));
    }, 1000);
  }

  afterUpdate(data) {
    alert(data);
    setTimeout(() => {
      location.reload();
    }, 2000);
  }
}